import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { authGuard } from './core/guards/auth/auth.guard';
import { LoginComponent } from './features/login/login.component';
import { UsersComponent } from './features/users/users.component';
import { ChartsComponent } from './features/charts/charts.component';
import { DevicesComponent } from './features/devices/devices.component';
import { LegalDisclaimerComponent } from './shared/components/legal-disclaimer/legal-disclaimer.component';
import { CookiePolicyComponent } from './features/cookie-policy/cookie-policy.component';
import { dataLoadedGuard } from './core/guards/data-loaded/data-loaded.guard';
import { SelectProjectComponent } from './features/select-project/select-project.component';
import { projectSelectedGuard } from './core/guards/project-selected/project-selected.guard';

const RESERVED_MATCHER_PREFIXES = new Set([
  'charts',
  'home',
  'login',
  'select-project',
  'users',
  'devices',
  'legal-disclaimer',
  'cookie-policy'
]);

export function contentHierarchyMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (!url || url.length === 0) {
    return null;
  }

  if (RESERVED_MATCHER_PREFIXES.has(url[0].path)) {
    return null;
  }

  // Allow:
  // - /<contentTypeId>
  // - /<contentTypeId>/<entityId>[/<contentTypeId>/<entityId>]...
  // - /<contentTypeId>/<entityId>/.../<contentTypeId>   (trailing type means ALL in that level)
  const isValidLength = url.length === 1 || url.length % 2 === 0 || (url.length % 2 === 1 && url.length >= 3);
  if (!isValidLength) {
    return null;
  }

  return { consumed: url };
}

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'select-project', component: SelectProjectComponent, canActivate: [authGuard] },
  { path: 'home', component: HomeComponent, canActivate: [authGuard, projectSelectedGuard] },
  { path: 'users', component: UsersComponent, canActivate: [authGuard, projectSelectedGuard, dataLoadedGuard] },
  { path: 'charts', component: ChartsComponent, canActivate: [authGuard, projectSelectedGuard, dataLoadedGuard] },
  { path: 'devices', component: DevicesComponent, canActivate: [authGuard, projectSelectedGuard, dataLoadedGuard] },
  { path: 'legal-disclaimer', component: LegalDisclaimerComponent, canActivate: [authGuard] },
  { path: 'cookie-policy', component: CookiePolicyComponent, canActivate: [authGuard] },
  { matcher: contentHierarchyMatcher, component: ChartsComponent, canActivate: [authGuard, projectSelectedGuard, dataLoadedGuard] },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
